import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType } from '../../constants';
import { ApplicationEventFilterAreaInteractionType } from '~shared/modules/application-event/constants';

export class GATrackingFilterAreaInteractionEvent implements GATrackingEvent {

  constructor(private type: ApplicationEventFilterAreaInteractionType) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.FilterAreaInteraction;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.FilterArea,
      label: this.type
    };
  }
}
